import { FC, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

import { DynamicFormCriteriaFlowScope, EnumFlowTypes, FlowTypes, TitleCallback } from "config";
import { DynamicFormFlow } from "containers/DynamicFormFlow/DynamicFormFlow";
import NotFound from "containers/NotFound/NotFound";
import { Layout, useLeadingNavigationContent } from "modules";
import { useScreenTestId } from "modules/hooks/useScreenTestId";

import { includes, startCase } from "lodash-es";

interface IProps {
  slug?: FlowTypes;
}

export const buildFlowTitle: TitleCallback<"slug"> = ({ match }) => {
  const formattedSlug = startCase(match?.params.slug);
  return formattedSlug;
};

const FlowRoute: FC<IProps> = props => {
  // Hooks
  const params = useParams();
  const slug = (params.slug as FlowTypes | undefined) ?? props.slug ?? "";
  const location = useLocation();
  const state = location.state as { flowScope?: DynamicFormCriteriaFlowScope } | null;
  const leadingNavigationButton = useLeadingNavigationContent();
  const screenTestId = useScreenTestId();

  // Memoized constants
  const flowScope = useMemo(() => (state || {})?.flowScope, [state]);

  return (
    <div data-testid={screenTestId}>
      <Layout
        className="flow-container dynamic-form-container"
        as="FullWidthLayout"
        backNav={{ hasBackNav: true, leadingNavigationButton }}
        content={{}}
        renderFallback={!includes(EnumFlowTypes, slug)}
        fallback={NotFound}>
        <DynamicFormFlow flowSlug={slug as FlowTypes} flowScope={flowScope} sessionFromStart />
      </Layout>
    </div>
  );
};

export default FlowRoute;
